/* eslint-disable */
<template>
  <section class="members-data">
    <div class="mt-2 md:mt-3 lg:mt-1">
      <Modal :visible="visible" :footer="null" :destroyOnClose="true" wrap-class-name="empty-modal" @cancel="visible=false">
        <h1>Edit email Time and title</h1>
        <Row class="my-2 gap-1">
          <Col span="11" class="m-auto">
            <DatePicker format="YYYY-MM-DD" class="w-full" v-model:value="when_to_send_date" :change="onRangeChangeDate" />
          </Col>
          <Col span="11" class="m-auto">
            <TimePicker
              format="HH:mm"
              class="w-full"
              v-model:value="when_to_send_time"
              value-format="HH:mm"
              @change="onRangeChangeTime"
            />
          </Col>
        </Row>

        <CustumLabel name="title" label="Title" :required="true">
          <Input type="text" v-model:value="title" />
        </CustumLabel>
        <RadioGroup v-model:value="toRule" class="flex flex-col">
          <Radio value="all">All users</Radio>
          <Radio value="complete"
            >Users with complete registration (users completed the survey/registration)</Radio
          >
          <Radio value="incomplete">Users with incomplete registration</Radio>
        </RadioGroup>
        <Button class="block mt-3"  @click="handleSendInvitation" block type="primary" :loading="loading">
          <div class="flex items-center justify-center gap-2">
            <span> <PhPaperPlaneTilt weight="duotone" size="18" /> Update</span>
          </div>
        </Button>
      </Modal>
      <Table
        :data-source="tableFormatedData"
        :columns="columns"
        :loading="ticketsQuery?.isFetching"
        :pagination="false"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'date'">
            <span v-if="record?.date" class="whitespace-nowrap w-full flex justify-center">{{
              record?.date
            }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'view'">
            <span class="whitespace-nowrap w-full flex justify-center">
              <Button
                type="primary"
                size="small"
                class="rounded shadow flex items-center gap-2"
                @click="showEmail(record?.key)"
              >
                <PhFile weight="duotone" :size="16" />
              </Button>
            </span>
          </template>
          <template v-if="column.key === 'rule'">
            <span class="whitespace-nowrap w-full flex justify-center">
              <p v-if="record?.rule == 'all'">All users</p>
              <p v-if="record?.rule == 'complete'">
                Users with complete registration (users completed the survey/registration)
              </p>
              <p v-if="record?.rule == 'incomplete'">Users with incomplete registration</p>
            </span>
          </template>
          <template v-if="column.key === 'sample'">
            <span class="whitespace-nowrap w-full flex justify-center">
              <Button
                type="primary"
                size="small"
                class="rounded shadow flex items-center gap-2 bg-success-600 border-0"
                @click="sendEmailSample(record?.key)"
              >
                <PhPaperPlaneRight weight="duotone" :size="16" />
              </Button>
            </span>
          </template>
          <template v-if="column.key === 'actions'">
            <span class="whitespace-nowrap w-full ga-2 flex justify-center">
              <Button
                type="primary"
                size="small"
                class="rounded shadow flex items-center gap-2 bg-green-600 border-0 mr-2"
                @click="editEmail(record?.title, record?.rule, record?.when_to_send, record?.key)"
              >
                <PhPen weight="duotone" :size="16" />
              </Button>
              <Button
                type="primary"
                size="small"
                class="rounded shadow flex items-center gap-2 bg-red-600 border-0"
                @click="deleteEmail(record?.key)"
              >
                <PhTrash weight="duotone" :size="16" />
              </Button>
            </span>
          </template>
        </template>
      </Table>
      <div
        v-if="customEmailsQuery && customEmailsQuery.data"
        class="mt-6 flex items-center justify-center"
      >
        <Pagination
          :current="customEmailsQuery?.data?.current_page"
          :total="customEmailsQuery?.data?.total"
          show-less-items
          @change="handlePaginationChange"
          :page-size="10"
        />
      </div>
    </div>
    <CustomEmailsQuery :page="page" :per_page="10" :key="page" />
  </section>
</template>
<script>
/* eslint-disable */
import {
  Table,
  InputSearch,
  Select,
  Spin,
  DatePicker,
  Pagination,
  Popconfirm,
  Button,
  Modal,
  Row,
  Col,
  message,
  TimePicker,
  RadioGroup,
  Radio,
  Input,
} from 'ant-design-vue';
import dayjs from 'dayjs';

// import handleResErrors from '@/utils/handleResErrors';
import CustumSelect from '@/components/shared/form/CustumSelect.vue';

import {
  PhCheck,
  PhCheckCircle,
  PhFile,
  PhFilePdf,
  PhPaperPlaneRight,
  PhPaperPlaneTilt,
  PhPen,
  PhProhibit,
  PhTrash,
  PhX,
  PhXCircle,
} from 'phosphor-vue';
import CustumInput from '@/components/shared/form/CustumInput.vue';
import debounce from 'lodash.debounce';
import membersApi from '@/services/apis/members.api';
import CustomEmailsQuery from '@/services/queries/members/CustomEmailsQuery.vue';
import { MEMBERS } from '@/store/types';
import CustumLabel from '@/components/shared/form/CustumLabel.vue';

export default {
  components: {
    Table,
    PhCheck,
    PhFilePdf,
    PhProhibit,
    Row,
    Col,
    CustumInput,
    Modal,
    PhTrash,
    PhX,
    InputSearch,
    PhFilePdf,
    PhFile,
    Select,
    Popconfirm,
    PhPaperPlaneRight,
    RadioGroup,
    Radio,
    TimePicker,
    Spin,
    Button,
    DatePicker,
    CustumSelect,
    Pagination,
    CustumLabel,
    Input,
    CustomEmailsQuery,
    PhCheckCircle,
    PhPen,
    PhPaperPlaneTilt,
    PhXCircle,
  },
  data() {
    return {
      columns: [
        {
          title: 'Date',
          dataIndex: 'date',
          key: 'date',
        },
        {
          title: 'View',
          dataIndex: 'view',
          key: 'view',
        },
        {
          title: 'Send to',
          dataIndex: 'rule',
          key: 'rule',
        },
        {
          title: 'Send Sample',
          dataIndex: 'sample',
          key: 'sample',
        },
        {
          title: 'Actions',
          dataIndex: 'actions',
          key: 'actions',
        },
      ],

      tableData: [],
      statues: ['In Progress', 'Backlog', 'Resolved'],
      search: '',
      searchData: [],
      page: 1,
      pageSize: 10,
      employer_id: null,
      type: 'year',
      searchStatus: null,
      when_to_send_date: null,
      when_to_send_time: '08:00',
      targetStatus: null,
      addCreditLoading: false,
      ticketShow: null,
      years: [],
      dateData: [
        // { id: 1, name: 'custom date' },
        { id: 'month', name: 'Monthly' },
        { id: 'year', name: 'Yearly' },
        { id: 'all', name: 'All Data' },
      ],
      statusData: [
        // { id: 1, name: 'custom date' },
        { id: 'pending', name: 'pending' },
        { id: 'approved', name: 'approved' },
        { id: 'rejected', name: 'rejected' },
      ],
      dateVal: dayjs(new Date().getFullYear() + '/12', 'YYYY/MM'),
      keyword: '',
      pdfLoading: false,
      rejectionMsg: '',
      creditModal: false,
      creditModal2: false,
      toRule: 'all',
      visible: false,
      modalUserId: null,
      title: '',
      editEmailId:null,
      detailsLoading: false,
      per_page: 10,
    };
  },
  computed: {
    dates() {
      if (!this.dateVal) return [null, null];
      if (this.type === 'month') {
        const start = dayjs(this.dateVal).startOf('month').format('YYYY-MM-DD');
        const end = dayjs(this.dateVal).endOf('month').format('YYYY-MM-DD');
        return [start, end];
      }

      if (this.type === 'year') {
        const start = dayjs(this.dateVal).startOf('year').format('YYYY-MM-DD');
        const end = dayjs(this.dateVal).endOf('year').format('YYYY-MM-DD');
        return [start, end];
      }

      return [null, null];
    },
    customEmailsQuery() {
      return this.$store.state.members.customEmailQuery;
    },
    tableFormatedData() {
      // if (!this.ticketsQuery || !this.ticketsQuery.data) return [];

      const data = this?.customEmailsQuery?.data?.data?.map((d, ix) => ({
        key: d?._id || ix,
        sent: d?.sent ?? false,
        date: this.convertUtcToLocalTime(d?.when_to_send ?? '')?.formattedString,
        when_to_send: d?.when_to_send,
        rule: d?.rule,
        title: d?.title,
      }));
      return data;
    },
  },
  methods: {
    async handleSendInvitation() {
      if (this.loading) {
        return;
      }

      if (!this.when_to_send_date || !this.when_to_send_time) {
        message.error('Please select When to send the email');
        return;
      }
      if (!this.title) {
        message.error('Please set a title');
        return;
      }
      const formData = new FormData();
      formData.append('when_to_send', `${this.when_to_send_date?.format('YYYY-MM-DD')} ${this.when_to_send_time}`);
      formData.append('rule', this.toRule);
      formData.append('title', this.title);

      this.error = null;
      this.loading = true;

      try {
        const res = await membersApi.editCustomEmail(formData, this.editEmailId);
        message.success(res.result || 'Custom email was edited successfully');
        if (this.customEmailsQuery) {
          this.customEmailsQuery.refetch();
        }
        this.loading = false;
        this.when_to_send = null;
      } catch (error) {
        // eslint-disable-next-line operator-linebreak
        this.error =
          error.response?.data?.message?.email[0] || error?.message || "Someting wen't wrong!";
        this.loading = false;
      }
    },
    showEmail(key) {
      this.$store.commit(MEMBERS.SET_MODAL_PROGRAM, key);
      this.$store.commit(MEMBERS.SET_MODAL_VIEW, true);
    },
    handleSearch(e) {
      this.debounceSearch(e.target.value, this);
    },
    handleSearchStatus(e) {
      this.searchStatus = e.target.value;
      this.page = 1;
    },
    handleChangeStatus(e) {
      this.targetStatus = e.target.value;
    },

    convertUtcToLocalTime(utcTimestamp, targetTimezone = null) {
      // Parse the UTC timestamp
      const date = new Date(utcTimestamp);

      // Determine which timezone to use (specified or local)
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timezoneToUse = targetTimezone || userTimezone;

      // Format options for displaying the date and time
      const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short',
        timeZone: timezoneToUse,
      };

      // Get formatted date and time in the specified timezone
      const formattedDateTime = date.toLocaleString(undefined, dateOptions);

      // For individual components, we need a workaround since JavaScript Date doesn't
      // directly support getting components in different timezones
      // We'll use the Intl.DateTimeFormat API for this

      const timeParts = {};
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezoneToUse,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
      });

      // Convert the parts to an object for easier access
      formatter.formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') {
          timeParts[part.type] = parseInt(part.value, 10);
        }
      });

      // Format individual components in a structured way
      const formattedComponents = `${timeParts.year}-${String(timeParts.month).padStart(
        2,
        '0',
      )}-${String(timeParts.day).padStart(2, '0')} ${String(timeParts.hour).padStart(
        2,
        '0',
      )}:${String(timeParts.minute).padStart(2, '0')}:${String(timeParts.second).padStart(2, '0')}`;

      return {
        original: utcTimestamp,
        formatted: formattedDateTime,
        timezone: timezoneToUse,
        isSpecifiedTimezone: Boolean(targetTimezone),
        components: {
          year: timeParts.year,
          month: timeParts.month,
          day: timeParts.day,
          hours: timeParts.hour,
          minutes: timeParts.minute,
          seconds: timeParts.second,
        },
        formattedString: formattedComponents,
      };
    },
    async deleteEmail(key) {
      // this.statusLoading = true;
      try {
        const res = await membersApi.deleteCustomEmail(key);
        message.success('Email was deleted successfully');

        if (this.customEmailsQuery) {
          await this.customEmailsQuery.refetch();
        }
      } catch (error) {
        message.error(handleResErrors(error), 10);
      } finally {
        // this.statusLoading = false;
      }
    },
    async editEmail(title, rule, when_to_send, key) {
      const formattedDateTime = this.convertUtcToLocalTime(when_to_send, 'America/Denver')?.formattedString?.split(" ") ?? '08:00';
      // this.statusLoading = true;
      this.when_to_send_date = dayjs(formattedDateTime[0]);
      this.when_to_send_time = formattedDateTime[1];
      this.toRule = rule;
      this.title = title;
      this.editEmailId = key;
      this.visible = true;
    },
    onRangeChangeDate(value, dateString) {
      this.when_to_send_date = dateString;
    },
    onRangeChangeTime(value, dateString) {
      this.when_to_send_time = dateString;
    },
    async sendEmailSample(key) {
      // this.statusLoading = true;
      try {
        const res = await membersApi.SendTestEmail(key);
        message.success('Email was sent successfully');

        if (this.customEmailsQuery) {
          await this.customEmailsQuery.refetch();
        }
      } catch (error) {
        message.error(handleResErrors(error), 10);
      } finally {
        // this.statusLoading = false;
      }
    },
    debounceSearch: debounce((search, app) => {
      // eslint-disable-next-line no-param-reassign
      app.search = search;
      // eslint-disable-next-line no-param-reassign
      app.page = 1;
    }, 400),
    handlePaginationChange(page) {
      // , filters, sorter, data
      this.page = page;
    },
    openTicket(ticketObj) {
      this.creditModal = true;
      this.ticketShow = ticketObj;
    },
    openTicket2(ticketObj) {
      this.ticketShow = ticketObj;
      this.creditModal2 = true;
    },
    openTicket3() {
      this.creditModal = false;
      this.creditModal2 = true;
    },
    setInput3(val) {
      if (val?.title) {
        this.title = val?.title?.value;
      }
    },
  },
};
</script>
